import React, { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getIsUserOwner, getIsStaff } from './modules/IDE/selectors/users';
import { resetProject } from './modules/IDE/actions/project';

// eslint-disable-next-line react/prop-types
const ProtectedSketchRoute = ({ component: Component, ...rest }) => {
  const project = useSelector((state) => state.project);
  const isUserOwner = useSelector(getIsUserOwner);
  // Staff (instructor/admin) may open any student's sketch — including Private ones — to edit in place.
  const isStaff = useSelector(getIsStaff);
  // A valid share link grants access even to a Private sketch (the token was validated server-side).
  const shareCapability = useSelector((state) => state.ide.shareCapability);
  const dispatch = useDispatch();
  const hasAccess =
    isUserOwner ||
    project.visibility !== 'Private' ||
    !!shareCapability ||
    isStaff;
  useEffect(() => {
    if (!hasAccess) {
      dispatch(resetProject());
    }
  }, [hasAccess, dispatch]);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!hasAccess) {
          return <Redirect to="/" />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedSketchRoute;
